import { listEnumNames, pb } from '@q6cyber/proto2es';

import { Component, Input, OnInit, inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';

import { MoneyFormGroup } from '../../interfaces/money.interface';
import { UiHelpersService } from '../../services';

@Component({
  selector: 'phoenix-money-control',
  templateUrl: './money-control.component.html',
  standalone: false,
})
export class MoneyControlComponent implements OnInit {
  @Input({ required: true }) form!: MoneyFormGroup;
  @Input() label = 'Balance';
  @Input() inputName = 'moneyCurrency';
  @Input() helperText = '';
  /** Restricts the picker to crypto currencies. */
  @Input() cryptoOnly = false;

  uiHelpers = inject(UiHelpersService);

  currencyList: string[] = [];
  currencyEnum = listEnumNames(pb.common.Currency);
  cryptoCurrencyEnum = listEnumNames(pb.common.CryptoCurrency);

  get currencyLabel(): string {
    return this.label === 'Balance' ? 'Currency' : `${this.label} Currency`;
  }

  get units(): FormControl {
    return this.form.controls.units;
  }

  get nanos(): FormControl {
    return this.form.controls.nanos;
  }

  ngOnInit(): void {
    this.uiHelpers.formatProtoEnum(this.currencyEnum);
    this.uiHelpers.formatProtoEnum(this.cryptoCurrencyEnum);

    this.currencyList = this.cryptoOnly
      ? [...this.cryptoCurrencyEnum]
      : [...this.currencyEnum, ...this.cryptoCurrencyEnum];
  }

  resetCurrency(): void {
    this.form.controls.selectedCurrency.patchValue('');
    this.form.removeControl('currency');
    this.form.removeControl('cryptoCurrency');
    this.form.markAsDirty();
  }

  onCurrencyChange(event: MatSelectChange<string>): void {
    const value = event.value;
    const isCrypto = this.cryptoCurrencyEnum.includes(value);

    this.form.selectConditionalControl(
      isCrypto ? 'cryptoCurrency' : 'currency',
      value
    );
  }
}
